import React from 'react';
interface PropsType {
    type?: 'button' | 'submit' | 'reset';
    variant?: 'primary' | 'primaryOutlined' | 'secondary' | 'secondaryOutlined'
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    customClass?: string;
    fullWidth?: boolean;
    children: React.ReactNode;
    disabled?: boolean;
    form?:string
}


const variantStyles = {
    primary: 'bg-[#5A60EC] text-white hover:bg-[#7b80f0] active:bg-[#5257d7] disabled:bg-[#EEEDF1] disabled:text-[#918EA2]',
    primaryOutlined: 'border lg:border-[1.5px] border-solid border-[#5A60EC] bg-white text-[#5A60EC] hover:bg-[#FEF1F6] active:border-[#5A60EC] active:bg-[#cccef9] active:text-[#5A60EC] disabled:bg-[#FFFFFF] disabled:border-[#918EA2] disabled:text-[#918EA2] ',
    secondary: 'bg-[#5A60EC] text-white hover:bg-[#433CC6] active:bg-[#31307F] disabled:bg-[#EEEDF1] disabled:text-[#918EA2]',
    secondaryOutlined: 'border lg:border-[1.5px] border-solid border-[#5A60EC] bg-white text-[#5A60EC] hover:bg-[#EEF2FF] active:bg-[#E1E8FE] active:text-[#433CC6] disabled:bg-[#FFFFFF] disabled:border-[#918EA2] disabled:text-[#918EA2]',
} as const;

const Button: React.FC<PropsType> = ({ form, children, customClass, fullWidth, onClick, disabled = false, type = "button", variant = "primary" }) => {

    return (

        <button form={form} disabled={disabled} type={type} onClick={onClick} className={`rounded-[32px] font-semibold font-inter px-8 lg:px-10 py-3 lg:py-4 flex items-center justify-center ${fullWidth ? 'w-full' : ''} ${variantStyles[variant]} ${customClass}`}>
            {children}
        </button>
    );
};

export default Button;